<section class="winners-card">
  <div class="winners-card__header">
    <img class="winners-card__ornament" src="assets/img/promotions/winners-ornament.png" alt="" aria-hidden="true" />
    <h2>{{ 'promotions.recentWinners' | translate }}</h2>
  </div>

  @if (isLoading()) {
    <div class="winners-card__loader">
      <korviu-loader></korviu-loader>
    </div>
  } @else if (winners().length) {
    <div class="winners-card__list">
      @for (
        winner of winnerRows();
        track winner.campaign_id + '-' + winner.claimed_at + '-' + (winner.reward.rank ?? 'unranked')
      ) {
        <article class="winners-card__item">
          <div class="winners-card__avatar">
            @if (winner.avatarUrl) {
              <img
                [src]="winner.avatarUrl"
                [alt]="winner.participant.first_name + ' ' + winner.participant.last_initial"
              />
            } @else {
              <span aria-hidden="true">{{ winner.participant.first_name.charAt(0) }}</span>
            }
          </div>
          <div class="winners-card__person">
            <strong>{{ winner.participant.first_name }} {{ winner.participant.last_initial }}</strong>
            <span>{{ winner.campaign_name }} · {{ winner.claimed_at | date: 'd MMM yy' }}</span>
          </div>
          <strong class="winners-card__amount">
            @if (winner.reward.value) {
              {{ winner.reward.value }}
            }
            {{ 'promotions.campaignDetails.rewardTypes.' + winner.reward.reward_type | translate }}
          </strong>
        </article>
      }
    </div>

    <a class="winners-card__view-all" routerLink="/workspace/promotions/winners">
      {{ 'promotions.viewAll' | translate }}
    </a>
  } @else {
    <korviu-no-data size="medium" [message]="'promotions.noRecentWinners' | translate"></korviu-no-data>
  }
</section>
